import Icon from "@assets/tsx/icon/pickerIcon";
import React from "react";
import Seperator from '../ribbon/ribbonSeparator';
import Ribbon from '../ribbon/index';
import { useA11yContext } from "@assets/spa/context/a11y";
function splitInSections(array, size) {
    return array.reduce((chunks, item, i) => {
        if (i % size === 0) {
            chunks.push([item]);
        }
        else {
            chunks[chunks.length - 1].push(item);
        }
        return chunks;
    }, []);
}
export default function CardStatsLg({ image, values, alignment, crop }) {
    const [state] = useA11yContext();
    const sections = splitInSections(!!values ? values : [], 4);
    const cropParams = crop === null || crop === void 0 ? void 0 : crop.computed;
    const has_image = (image === null || image === void 0 ? void 0 : image.url) && (state === null || state === void 0 ? void 0 : state.illustrations) !== false;
    return (React.createElement("div", { className: `ltg-card-stats-lg ${THEME === 'gtc' ? 'ltg-card-stats-lg-white' : ''}` },
        has_image && (React.createElement("div", { className: "ltg-card-stats-lg-img-wrap" },
            React.createElement("img", { style: { transform: cropParams }, className: "ltg-card-stats-lg-img-wrap-image", src: image.url, alt: (image === null || image === void 0 ? void 0 : image.alt) || 'nuotrauka' }))),
        React.createElement("div", { className: "ltg-card-stats-lg-item-wrap" }, sections.map((card, i) => (React.createElement("section", { className: `ltg-card-stats-lg-item-wrap-content ${THEME === 'gtc' ? 'ltg-card-stats-lg-grid' : 'ltg-card-stats-lg-grid-ltg'}`, key: i },
            React.createElement(React.Fragment, null,
                generateSeperator(THEME),
                React.createElement("div", { className: 'ltg-card-stats-lg-item-wrap-content-container container' }, card.map((item) => React.createElement(LtgStatsCard, Object.assign({}, Object.assign(Object.assign({}, item), { alignment }), { key: item._id })))))))))));
}
const LtgStatsCard = function ({ _id, label, icon, value, alignment }) {
    return (React.createElement("div", { className: "ltg-card-stats-lg-item-wrap-content-item", key: _id },
        (value && THEME === 'gtc') && React.createElement("div", { className: 'ltg-card-stats-lg-item-wrap-content-item-bubble' }),
        React.createElement("h1", { className: 'ltg-card-stats-lg-item-wrap-content-item-heading', role: "presentation" }, value),
        React.createElement("p", { className: 'ltg-card-stats-lg-item-wrap-content-item-description' }, label),
        React.createElement("div", { className: 'ltg-card-stats-lg-item-wrap-content-item-icon', style: { fontSize: '2.5rem', marginTop: !!alignment ? 'auto' : '0px' } }, (icon === null || icon === void 0 ? void 0 : icon.iconClassName) && (React.createElement(Icon, Object.assign({}, icon))))));
};
const generateSeperator = function (theme) {
    switch (theme) {
        case 'gtc':
            return React.createElement("div", { className: 'ltg-card-stats-lg-item-wrap-content-timeline' });
        default:
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: 'ltg-card-stats-lg-ribbon-desktop' },
                    React.createElement(Seperator, { offset: { size: '50%' }, color_left: "black", color_right: "white" })),
                React.createElement("div", { className: 'ltg-card-stats-lg-ribbon-tablet' },
                    React.createElement("div", { className: 'ltg-card-stats-lg-ribbon-seperator' },
                        React.createElement(Ribbon, { side: "bottom" }),
                        React.createElement("div", { style: { height: '100%' } }),
                        React.createElement(Ribbon, { side: "top" })))));
    }
};
